const mEditionAssetContentsModalCreateContent = {
  mEditionAssetContentsModalCreateContent: {
    alerts: {
      createContenidoNodo: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El nuevo contenido fue creado exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'CREAR',

    inputs: {
      nombre: {
        label: 'Escribe aquí un nombre',
        message: '* De 5 a 255 caracteres'
      }
    },

    title: 'Nuevo Contenido',

    validation: {
      nodo: {
        nombre: {
          maxLength: 'La longitud máxima permitida es de 255 caracteres.',
          minLength: 'La longitud mínima permitida es de 5 caracteres.',
          required: 'Nombre de contenido es requerido.'
        }
      }
    }
  }
}

export default mEditionAssetContentsModalCreateContent
